/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetBatteryStatusResponse } from '../models/ApiResponseGetBatteryStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BatteryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 12v 배터리 상태 조회
   * 12v 배터리 상태를 조회합니다.
   * @returns ApiResponseGetBatteryStatusResponse OK
   * @throws ApiError
   */
  public getBatteryStatus2({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetBatteryStatusResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/battery/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 12v 배터리 상태 조회
   * 12v 배터리 상태를 조회합니다.
   * @returns ApiResponseGetBatteryStatusResponse OK
   * @throws ApiError
   */
  public getBatteryStatus3({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetBatteryStatusResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/battery',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
}
